/*
 * Public API Surface of unb-questionario-componente
 */

 export * from './lib/unb-questionario-componente';
